import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import i18n from 'FRONTEND/utils/i18n';

const ModalConfirmation = ({
  open,
  onClose,
  message,
  title,
  cancelLabel = '',
  confirmLabel = '',
}) => {
  const handleClose = (response) => {
    setIsOpen(false);
    onClose(response);
  };

  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => handleClose(false)}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle variant='h5' id='alert-dialog-title'>{title || i18n._('Confirm appointment')}</DialogTitle>
      <DialogContent>
        <Typography component='span'>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
        <Button
          onClick={() => handleClose(false)}
          variant='outlined'
        >
          {cancelLabel || i18n._('Cancel')}
        </Button>
        <Button
          onClick={() => handleClose(true)}
          variant='contained'
          autoFocus
        >
          {confirmLabel || i18n._('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmation;
